import React, { ReactElement } from 'react';
import { Button, Flex, Text } from '@chakra-ui/react';
import { ModalAnnouncementVariantProps, SharedModalProps } from 'types/Modal';
import { useNavigate } from 'react-router-dom';
import { CustomModal } from '../CustomModal';
import { CustomModalContent } from '../CustomModalContent';

type Props = SharedModalProps & ModalAnnouncementVariantProps;

export const AnnouncementModal = ({
  isShown,
  title,
  externalLink,
  internalLink,
  message,
  handleClose: closeModal,
  onClose,
}: Props): ReactElement => {
  const navigate = useNavigate();
  const handleClose = (): void => {
    if (onClose) onClose();
    if (closeModal) closeModal();
  };

  return (
    <CustomModal isOpen={isShown} onClose={handleClose} title={title} placement="center" size="lg">
      <CustomModalContent p={{ base: '15px 20px 40px', md: '25px 20px' }} scrollbar="hidden">
        <Text textStyle="body.m.regular" whiteSpace="pre-wrap">
          {message}
        </Text>
        <Flex mt="m" justify="center" alignItems="center" flexDir="column" gap="m">
          {internalLink && (
            <Button
              variant="primary"
              onClick={() => {
                navigate(internalLink.url);
                handleClose();
              }}
              width="fit-content"
              minWidth="200px"
            >
              {internalLink.label}
            </Button>
          )}
          {externalLink && (
            <Button
              variant={internalLink && externalLink ? 'secondary' : 'primary'}
              onClick={() => {
                window.open(externalLink.url, '_blank');
              }}
              width="fit-content"
              minWidth="200px"
            >
              {externalLink.label}
            </Button>
          )}
        </Flex>
      </CustomModalContent>
    </CustomModal>
  );
};
